import React from 'react'
import PropTypes from 'prop-types'
import { IonIcon } from 'controls'
import { iadProvitionalColors } from 'theme/colors'

import { ModalConfirm } from 'components/Modals'

import styles from './styles'

const ParentErrorModal = ({ isOpen, onClose }) => (
  <ModalConfirm
    showRejectButton={false}
    isOpen={isOpen}
    onConfirm={onClose}
    onCancel={onClose}
    buttonConfirmLabel="Entendido"
    message=""
  >
    <IonIcon
      size="large"
      style={{ color: iadProvitionalColors.error }}
      icon="md-alert-circle-outline"
    />
    <h3 className="title">Padrino no válido</h3>
    <p className="message">
      El broker ya no es válido como padrino, por favor, selecciona otro
    </p>
    <style jsx>{styles}</style>
  </ModalConfirm>
)

ParentErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default ParentErrorModal
